/**
 * Localization messages for RulesDashboard component
 */
import sharedMessages from '../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../utils/localization';

const componentMessages = {
  // Page header
  'Rule Recommendations': 'ruleRecs.dashboard.title',
  'Top recommended rules from Intelligent Recommendations for quick conversion to Technical or Birthright Rule':
    'ruleRecs.dashboard.subtitle',

  // Search and filters
  '{count, plural, one {# New Rule Recommendation Found} other {# New Rule Recommendations Found}}':
    'ruleRecs.dashboard.newRecommendations',

  // Zero states
  'Try running the Rule Recommendations job to generate Rules':
    'ruleRecs.dashboard.zeroState.runJobHint',
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export default invertedMessages;
